export enum ListsSearchTypes {
    INTL_HUMAN = 'intlHumanVerified',
    INTL_MACHINE = 'intlMachineVerified',
    USA_HUMAN = 'usaHumanVerified',
    USA_MACHINE = 'usaMachineVerified',
}
